import React from 'react';
import styled from 'styled-components/macro';
import { Furniture } from '../../lib/modelBuilder/entities/Furniture';
import { Cabinet } from '../../lib/modelBuilder/entities/Cabinet';
import SchemaDimensions from './SchemaDimensions';

interface Props {
  item: Furniture | Cabinet;
}

const SchemaDimensionsContainer = ({ item }: Props) => {
  return (
    <WrapperDMStyled
      id="schema-furniture"
      className="w-full bg-white absolute bottom-0 z-20 overflow-auto"
    >
      <SchemaDimensions item={item} />
    </WrapperDMStyled>
  );
};

const WrapperDMStyled = styled.div`
  height: 100%;
`;

export default SchemaDimensionsContainer;
